{
  "translation": {
    "button": {
      "ok": "D'accord",
      "cancel": "Annuler",
      "clear": "Clair",
      "login": "Connexion",
      "logout": "Se déconnecter",
      "delete": "Supprimer",
      "new": "Nouvelle",
      "back": "Dos",
      "save": "sauvegarder",
      "create": "Créer",
      "export": "Exporter",
      "import": "Importer",
      "upload": "Télécharger",
      "open": "Ouvrir",
      "iframe": "IFrame",
      "newTab": "Nouvel onglet",
      "search": "Recherche",
      "refresh": "Rafraîchir",
      "compare": "Comparer",
      "publish": "Publier",
      "discard": "Jeter",
      "deleteAll": "Supprimer tout",
      "download": "Télécharger",
      "generate": "Générer"
    },
    "tooltip": {
      "enableOptional": "Coché signifie que les fonctionnalités optionnelles seront affichées dans le configurateur."
    },
    "dialogBox": {
      "error": "Erreur",
      "success": "Succès",
      "ConnectionError": "Erreur de connexion"
    },
    "labels": {
      "lovOptions": "Options LOV ({{name}})",
      "description": "Description",
      "name": "Nom",
      "email": "E-mail",
      "userManagement": "Gestion des utilisateurs",
      "roleManagement": "Gestion des rôles",
      "apiKeyManagement": "Gestion des clés API",
      "applicationManagement": "Gestion des applications",
      "featureFlagsManagement": "Gestion des indicateurs de fonctionnalité",
      "personalDetails": "Détails personnels",
      "roleAssociation": "Association de rôle",
      "createUser": "Créer un utilisateur",
      "editUser": "Modifier l'utilisateur",
      "isAdmin": "Administrateur",
      "createRole": "Créer un rôle",
      "editRole": "Modifier le rôle",
      "isDefault": "Défaut",
      "createApiKey": "Créer une clé API",
      "editApiKey": "Modifier la clé API",
      "permission": "Autorisation",
      "read": "Lire",
      "write": "Écrire",
      "yes": "Yes",
      "no": "Non",
      "key": "Clé",
      "applicationUrl": "URL de l'application",
      "access": "Autorisation",
      "userEmail": "Utilisateur du service",
      "emailId": "E-mail",
      "isService": "Utilisateur des services",
      "isPdm": "PDM User",
      "isAce": "Ace User",
      "roles": "Roles",
      "accessType": "Autorisation",
      "isActive": "Actif",
      "isHidden": "Caché",
      "isEditable": "Modifiable",
      "isVisible": "Montrer",
      "channels": "Canaux",
      "deleteConfirm": "Confirmer la suppression",
      "administration": "Administration",
      "dataMaintainance": "Maintenance des données",
      "featureFlags": "Indicateurs de fonctionnalité",
      "flagName": "Nom de l’indicateur",
      "applicationName": "Nom de l’application",
      "application": "Nom de l’application",
      "page": "Page",
      "configuration": "Configuration",
      "configurationId": "Identifiant de configuration",
      "token": "Jeton",
      "language": "Langue",
      "apiKey": "clé API",
      "country": "Pays",
      "none": "Aucun",
      "headerLess": "En-tête moins",
      "note": "Note",
      "copyApiKey": "J'ai copié la clé.",
      "product": "Produit",
      "id": "Identifiant",
      "code": "Code",
      "productCode": "Code produit",
      "languages": "Langages",
      "recordsPerPage": "Dossiers",
      "materialCode": "Code matériel",
      "countryCode": "Code postal",
      "currencyCode": "Code de devise",
      "price": "Prix",
      "editPriceListMap": "Modifier le mappage des listes de prix",
      "editLanguageAssociation": "Modifier l'association de langue",
      "materialImages": "Images",
      "languageCode": "Code de langue",
      "shortSalesText": "Texte de vente court",
      "longSalesText": "Texte de vente longue",
      "view": "Voir",
      "sc": "SC Code",
      "pd": "PD Code",
      "bs": "BS Code",
      "bu": "BU Code",
      "mag": "MAG Code",
      "ag": "AG Code",
      "image": "Image",
      "languageManagement": "Gestion des langues",
      "createLanguage": "Créer une langue",
      "editLanguage": "Modifier la langue",
      "supportDetails": "Détails de l'assistance",
      "browserCompatibility": "Compatibilité du navigateur",
      "enableOptional": "Activer les fonctionnalités facultatives",
      "apikeyDetails": "Clé API Détails",
      "feature": "Caractéristiques",
      "message": "Message",
      "url": "URL",
      "create": "Créer",
      "edit": "Modifier",
      "map": "Carte des prix",
      "newMap": "Nouvelle carte des prix",
      "productId": "Code produit",
      "productDescription": "Description du produit",
      "agCode": "Code agricole",
      "packageType": "Type de paquet",
      "countries": " Des pays",
      "marketManagement": "Gestion de marché",
      "createMarket": "Créer un marché",
      "editMarket": "Modifier le marché",
      "markets": "Marchés",
      "market": "Markt",
      "state": "État",
      "createdBy": "Créé par",
      "modifiedBy": "Modifié par",
      "deletedBy": "Supprimé par",
      "createdOn": "Créé sur",
      "modifiedOn": "Modifié le",
      "versionId": "Version Id",
      "releaseId": "Release Id",
      "deletedOn": "Supprimé le",
      "lastLogin": "Dernière connexion",
      "countryName": "Nom du pays",
      "packagePath": "Chemin du paquet",
      "createdFromName": "Créé à partir du nom",
      "createdFromId": "Créé à partir de l'identifiant",
      "editMarketAssociation": "Modifier l'association du marché",
      "permissions": "Autorisations",
      "group": "Groupe",
      "resource": "Ressource",
      "privileges": "Privilèges",
      "properties": "Propriétés",
      "compare": "Comparer",
      "details": "Détails",
      "lastUpdatedOn": "Dernière mise à jour le",
      "notificationManagement": "Gestion des notifications",
      "queueManagement": "Gestion de file d’attente",
      "notifications": "Notification",
      "reports": "Rapports",
      "releaseManagement": "Gestion des publications de produits",
      "productVersionMappingManagement": "Mappage des versions de produits",
      "type": "Taper",
      "targetId": "ID cible",
      "action": "Action",
      "refresh": "Rafraîchir",
      "active": "actif",
      "status": "Statut",
      "processedOn": "Traité le",
      "log": "enregistrer",
      "sync": "synchroniser",
      "retrigger": "Redéclencher",
      "userAccessType": "Types d'accès",
      "propertyManagement": "Gestion de la propriété",
      "applicability": "Applicabilité",
      "listOfValues": "Liste de valeurs",
      "origin": "Origine",
      "default": "Défaut",
      "configit": "Configit",
      "pdm": "PDM",
      "option": "Option",
      "selectionType": "Type de sélection",
      "inactive": "Inactif",
      "actions": "Actions",
      "valueType": "Type de valeur",
      "restrictUpdate": "(La sélection est irréversible)",
      "values": "Valeurs",
      "channel": "canal",
      "views": "Voir",
      "isLocal": "estLocal",
      "multiNumericManagement": "Gestion multi-numérique",
      "others": "Autres",
      "columns": "Columns",
      "filters": "Filters",
      "source": "Source",
      "txnId": "ID de transaction",
      "user": "Utilisateur",
      "syncedOn": "Synchronisé le",
      "error": "Erreur",
      "activities": "Activités",
      "version": "Version",
      "startedOn": "Commencé le",
      "remarks": "Remarques",
      "rules": "Règles",
      "effectivity": "Efficacité",
      "salestext": "Texte de vente",
      "selectAll": "Tout",
      "download": "Télécharger",
      "isRequired": "Obligatoire",
      "fromDate": "De",
      "toDate": "À",
      "fileName": "Nom du fichier",
      "reportManagement": "Gestion des rapports",
      "descopeList": "Liste de retrait de périmètre",
      "coe": "COE",
      "procosForPpl": "ProCoS pour PPL"
    },
    "header": {
      "image": "Image",
      "price": "Prix",
      "productHierarchy": "Hiérarchie des produits",
      "languageAssociation": "Association linguistique",
      "salesText": "Texte de vente",
      "roles": "Rôle",
      "users": "Utilisatrice",
      "apikeys": "Clé API",
      "applications": "Application",
      "channels": "Canaux",
      "languages": "Langue",
      "associatedLanguages": "Langues associées",
      "priceListMap": "Carte des tarifs",
      "productCatalog": "Catalogue de produits",
      "internalProductCatalog": "Catalogue de produits interne",
      "productConfiguration": "Configuration du produit",
      "archivedConfiguration": "Configuration archivée",
      "marketAssociation": "Association du marché",
      "countries": "Des pays",
      "markets": "Marché",
      "associatedMarkets": "Marchés associés",
      "featureFlags": "Indicateur de fonctionnalité",
      "images": "Images",
      "properties": "Propriétés",
      "propertyAssociation": "Gestion de l'association des propriétés",
      "featurePropertyAssociation": "Association des propriétés des fonctionnalités",
      "technicalInfo": "Informations techniques sur les pièces",
      "views": "Voir",
      "multiNumericFeature": "Multi-numérique",
      "notification": "Notification",
      "queue": "File d'attente",
      "productRelease": "Publication de produit",
      "productVersionMapping": "Mappage des versions de produits"
    },
    "reports": {
      "descopeList": "Liste de déclassement",
      "extractForCoe": "Extraction pour CoE"
    },
    "footer": {
      "env": "Env",
      "termsAndConitons": "Termes et conditions",
      "release": "R",
      "sprint": "SP",
      "build": "Construire",
      "branch": "Branche",
      "date": "Date"
    },
    "messages": {
      "error": {
        "204": "Aucun changement de configuration à notifier",
        "400": "Données invalides.",
        "401": "Session expirée veuillez vous reconnecter",
        "403": "Vous n'avez pas accès. Veuillez contacter l'administrateur.",
        "404": "Ressource introuvable",
        "500": "Une erreur s'est produite Veuillez réessayer plus tard"
      },
      "success": {
        "create": "Créé avec succès !",
        "update": "Mis à jour avec succés!",
        "delete": {
          "general": "Supprimé avec succès",
          "users": "Supprimé avec succès ({{length}}) utilisateur(s) : {{list}}",
          "roles": "Supprimé avec succès ({{length}}) rôle(s) : {{list}}",
          "apikeys": "Supprimé avec succès ({{length}}) Clé(s) api : {{list}}",
          "applications": "Supprimé avec succès ({{length}}) application(s) : {{list}}",
          "languages": "Supprimé avec succès({{length}}) Langue(s) : {{list}}",
          "markets": "Supprimé avec succès ({{length}}) marché(s) : {{list}}",
          "featureFlags": "Supprimé avec succès({{length}}) Indicateur(s) de fonctionnalité : {{list}}",
          "properties": "Successfully deleted ({{length}}) property(s) : {{list}}",
          "multiNumeric": "Supprimé avec succès({{length}}) multi-numérique de fonctionnalité : {{list}}",
          "prices": "Successfully deleted prices"
        },
        "import": "Téléchargement du fichier réussi. Importation des données...",
        "upload": {
          "general": "Données téléchargées avec succès !",
          "productHierarchy": "Téléchargement des données réussi.<1/>Veuillez utiliser le bouton « Comparer » pour afficher et publier les modifications.",
          "technicalInfo": "<1>Succès</1> - Importation des données réussie pour {{file}} à {{timestamp}}. Veuillez consulter le fichier journal téléchargé {{logFileName}} pour plus de détails."
        },
        "publish": "Données publiées avec succès !",
        "discard": "Données supprimées avec succès !",
        "retriggeredSuccessfully": "Redéclenché avec succès !"
      },
      "fail": {
        "create": "La création a échoué !",
        "update": "La mise à jour a échoué !",
        "download": "Le téléchargement a échoué !",
        "delete": {
          "general": "La suppression a échoué ",
          "users": "Echec de la suppression pour utilisateur(s)  ({{length}}): {{list}}",
          "roles": "Echec de la suppression pour rôle(s)({{length}}): {{list}}",
          "apikeys": "Echec de la suppression pour Clé(s) api ({{length}}): {{list}}",
          "applications": "Echec de la suppression pour application(s) ({{length}}): {{list}}",
          "languages": "Echec de la suppression pour Langue(s) ({{length}}): {{list}}",
          "markets": "Echec de la suppression pour marché(s) ({{length}}): {{list}}",
          "featureFlags": "Echec de la suppression pour Indicateur(s) de fonctionnalité ({{length}}): {{list}}",
          "properties": "Deletion failed for property(s) ({{length}}): {{list}}",
          "prices": "Deletion failied for prices",
          "multiNumeric": "Echec de la suppression pour multi multi-numérique ({{length}}): {{list}}"
        },
        "export": "Échec de l'exportation !",
        "upload": "Échec du téléchargement !",
        "import": "Échec de l'importation !",
        "publish": "Échec de la publication !",
        "discard": "Échec de la suppression !",
        "getDetails": "Une erreur s'est produite. Impossible de récupérer les détails !",
        "fileSize": "La taille du fichier ne peut pas dépasser {{size}}MB",
        "fileFormat": "Seuls les fichiers avec l'extension {{format}} sont acceptés",
        "importWithFileInfo": "<1>Échec</1> : l'importation des données a échoué pour {{file}} à {{timestamp}}.",
        "importWithFileInfoAndLog": "<1>Échec</1> : l'importation des données a échoué pour {{file}} à {{timestamp}}. Veuillez consulter le fichier journal téléchargé {{logFileName}} pour plus de détails.",
        "configurationId": "ID de configuration ({{id}}) introuvable",
        "fileName": "{{fileName}} - Name should be less than {{fileNameSize}} characters",
        "retriggeredFailed": "Échec du redéclenchement !",
        "generate": "Échec de la génération !"
      },
      "confirmation": {
        "delete": {
          "applications": "Suppression '{{applicationNames}}'<br/>- InActive tous ses indicateurs de fonctionnalité correspondants<br/>- Supprime toutes ses associations avec la clé API<br/><br/>Cette action est irréversible.<br/><br/>Êtes-vous sûre de vouloir supprimer ?",
          "featureFlags": "Suppression '{{featureFlagNames}}'<br/>- Supprime toutes ses associations avec la clé API<br/><br/>Cette action est irréversible.<br/><br/>Êtes-vous sûre de vouloir supprimer ?"
        }
      },
      "login": "veuillez vous reconnecter",
      "session": "Session expirée",
      "unauthenticated": "L'utilisateur n'est pas connecté. Veuillez vous connecter. Si le problème persiste, veuillez contacter votre administrateur.",
      "tryAgain": "Veuillez réessayer après un certain temps",
      "nameErrorMessage": "Merci d'entrer un nom valide",
      "codeErrorMessage": "Veuillez entrer un code valide",
      "emailErrorMessage": "Format d'email invalide",
      "urlErrorMessage": "Format d'URL non valide",
      "deleteConfirmation": "Voulez-vous vraiment supprimer ?",
      "deleteEnumConfirmation": "La suppression de l'énumération rendra également toutes ses options inactives.",
      "deletePricesConfirmation": "Prices will be deleted permanently.<br/>Are you sure you want to continue?",
      "copyApiKeyMessage": "La récupération de la clé n'est pas possible une fois cette boîte de dialogue fermée. Copiez la clé pour fermer cette boîte de dialogue.",
      "noServiceUserAvailable": "Aucun utilisateur de service disponible",
      "noSearchRecords": "Aucun enregistrement trouvé pour '{{searchValue}}'",
      "noDataFound": "Aucune donnée disponible.",
      "errorParsingLog": "Erreur lors de l'analyse du journal",
      "noCountriesFound": "Aucun pays trouvé",
      "noApplicationsFound": "Aucune application trouvée",
      "browserNotSupported": "Navigateur non pris en charge",
      "browserNotSupportedMessage": "Vous utilisez un navigateur ou une version de navigateur qui n'est pas officiellement pris en charge.<1/><1/>Vous pouvez continuer à utiliser l'application ou utiliser l'une des dernières versions du navigateur pris en charge pour une meilleure expérience.",
      "supportedBrowsers": "Les navigateurs supportés sont",
      "100LimitErrorMessage": "Veuillez limiter le texte à 100 caractères",
      "deleteLimitMessage": "Un maximum de {{limit}} enregistrements peuvent être supprimés à la fois.",
      "logoutMessage": "L’utilisateur est déconnecté. Veuillez vous reconnecter à l’application.",
      "descriptionErrorMessage": "Please enter a valid description",
      "pageErrorMessage": "Please enter a valid page",
      "maxLimitErrorMessage": "Seuls {{limit}} caractères autorisés.",
      "minLimitErrorMessage": "Minimum {{limit}} caractères requis.",
      "invalidInputErrorMessage": "Entrée invalide."
    }
  }
}